"use strict";

exports.__esModule = true;
exports.MetricTableColumnController = void 0;
var _react = require("react");
var _URLFilterContext = require("../../Core/URLFilter/URLFilterContext");
var _createTableColumns = require("./createTableColumns");
var _fetchSection = require("../../VIMANAMetrics/Sections/fetchSection");
var _MetricsFilters = require("../common/MetricsFilters");
var _types = require("./types");
var getMetricItems = function getMetricItems() {
  var metrics = (0, _fetchSection.fetchSection)("metrics");
  return (0, _MetricsFilters.flattenMetrics)(metrics);
};
var findMetricPredicate = function findMetricPredicate(metric) {
  return function (metricItem) {
    return metricItem.name === metric;
  };
};
var getSelectedMetrics = function getSelectedMetrics(urlFilter, metricItems, defaultColumns) {
  if (defaultColumns === void 0) {
    defaultColumns = [];
  }
  var urlMetrics = urlFilter.filters.metrics;
  var metricNames = urlMetrics ? urlMetrics.split(",") : defaultColumns.map(function (_ref) {
    var name = _ref.name,
      section = _ref.section;
    return section === "metrics" ? name : "";
  });
  return metricNames.reduce(function (selectedMetrics, metric) {
    if (!metric) return selectedMetrics;
    var found = defaultColumns.find(findMetricPredicate(metric));
    if (!found) {
      found = metricItems.find(findMetricPredicate(metric));
    }
    if (found) {
      return [].concat(selectedMetrics, [found]);
    }
    return selectedMetrics;
  }, []);
};
var MetricTableColumnController = exports.MetricTableColumnController = function MetricTableColumnController(props) {
  var children = props.children,
    _props$columns = props.columns,
    columns = _props$columns === void 0 ? [] : _props$columns,
    _props$columnProps = props.columnProps,
    columnProps = _props$columnProps === void 0 ? [] : _props$columnProps;
  var aggregateColumns = columns.filter(function (_ref2) {
    var props = _ref2.props;
    return props.section === "aggregates";
  });
  var metricItems = getMetricItems();
  var urlFilter = (0, _react.useContext)(_URLFilterContext.URLFilterContext);
  var selectedMetrics = getSelectedMetrics(urlFilter, metricItems, columnProps);
  var tableColumns = aggregateColumns.concat((0, _createTableColumns.createTableColumns)(selectedMetrics));
  return children({
    columns: tableColumns,
    columnProps: tableColumns.map(function (child) {
      return child.props;
    }),
    selected: selectedMetrics,
    metricItems: metricItems
  });
};